export default function consoleMessage(view: string, message: string, type: 'success' | 'error' | 'warning') {
   const colors = {
      success: '#54D62C',
      warning: '#FFC107',
      error: '#FF4842',
   }

   return console.log(`%c ${view}: %c${message}`, `color: #1CCAFF; font-weight: bold;`, `color: ${colors[type]};`)
}
